import { useEffect } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, ClickAwayListener, IconButton, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SimpleTable from "../../../components/SimpleTable";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { BASE_URL, deleteData } from "../../Utils/Baseurl";
import { useState } from "react";
import { useLoading } from "../../../context/loadingcontext";
import Swal from "sweetalert2";
import { useSnackbar } from "../../../components/SnackbarProvider";
import CanAccess from "../../../components/permission/CanAccess";
import { useAuth } from "../../../context/AuthContext";
import TaskView from "./components/TaskView";
import axios from "axios";

const TaskCreationTabel = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [taskID, setTaskID] = useState();
  const [taskData, setTaskData] = useState([]);

  const handleNewTaskCreation = () => {
    navigate("/task-creation/add-task-creation");
  };
  const { rolePermission } = useAuth();

  const currentUser = sessionStorage.getItem("currentUser");

  const userColumns = [
    { header: "PROJECT CODE", key: "project_name" },
    { header: "TASK CODE", key: "task_code" },
    { header: "TASK NAME", key: "task_title" },
    { header: "TEAM", key: "teams" },
    { header: "ASSIGNEE", key: "assignee_name" },
    { header: "MILESTONE", key: "milestone_name" },
    { header: "STATUS", key: "status" },
    { header: "ACTION", key: "action" },
  ];

  const handleEdit = (id, data) => {
    navigate("/task-creation/edit-task-creation", {
      state: { type: "edit", data: data },
    });
  };
  const handleView = (id, data) => {
    setIsPanelOpen(true);
    setTaskID(id);
  };

  const handleDelete = async (id, data) => {
    const result = await Swal.fire({
      title: "Are you sure you want to delete this task creation?",
      text: "This action is irreversible and cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) {
      setCirleLoading(true);
      try {
        const response = await deleteData(`api/taskcreation/${id}/`);
        if (response.status) {
          showSnackbar(response?.message, "success");
          fetchListData();
        } else {
          showSnackbar(response?.message, "error");
        }
      } catch (error) {
        let message = "An unexpected error occurred";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
          fetchListData();
        } else if (error?.message) {
          message = error.message;
        }

        showSnackbar(message, "error");
      } finally {
        setCirleLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchListData();
  }, []);

  const fetchTaskDetails = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(
        `${BASE_URL}api/gettaskdetails/${currentUser}/${taskID}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTaskData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (taskID) {
      fetchTaskDetails();
    }
  }, [taskID]);

  const fetchListData = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(
        `${BASE_URL}api/gettask/${currentUser}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const actionVisibility = {
    showEdit: CanAccess.can(rolePermission, "Task Master", "Task Edit"),
    showView: CanAccess.can(rolePermission, "Task Master", "Task View"),
    showDelete: CanAccess.can(rolePermission, "Task Master", "Task Delete"),
  };

  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="medium">
            Task Creation
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the task creation list here.
          </MaterialTypography>
        </Stack>

        {/* <CanAccess module="Task Master" component="Task Add"> */}
        <MaterialButton
          variant="gradient"
          color="dark"
          size="small"
          startIcon={<AddIcon />}
          onClick={handleNewTaskCreation}
        >
          Add Task Creation
        </MaterialButton>
        {/* </CanAccess> */}
      </Stack>

      <SimpleTable
        columns={userColumns}
        data={data}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
        isLoading={isLoading}
        actionVisibility={actionVisibility}
      />
      {isPanelOpen && (
        <ClickAwayListener onClickAway={() => setIsPanelOpen(false)}>
          <Box
            sx={{
              position: "fixed",
              top: 0,
              right: isPanelOpen ? 0 : "-450px",
              width: 350,
              height: "100%",
              bgcolor: "background.paper",
              boxShadow: 4,
              p: 2,
              transition: "right 0.3s ease-in-out",
              zIndex: 1300,
              overflowY: "auto",
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Chrome, Edge
              },
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={1}
            >
              <MaterialTypography variant="h6" color="dark">
                Task Code : {taskData?.task_code}
              </MaterialTypography>
              <IconButton
                onClick={() => setIsPanelOpen(false)}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <lord-icon
                  src="https://cdn.lordicon.com/ebyacdql.json"
                  trigger="hover"
                  colors="primary:#e83a30"
                  style={{ width: "28px", height: "28px" }}
                ></lord-icon>
              </IconButton>
            </Box>
            <TaskView taskData={taskData} fetchTaskDetails={fetchTaskDetails} />
          </Box>
        </ClickAwayListener>
      )}
    </DashboardLayout>
  );
};

export default TaskCreationTabel;
